import { useState, useEffect } from 'react';
const useAsync = function (fn, deps) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    defaults = {},
    forceFetch,
    defer
  } = options;
  const [loading, setLoading] = useState(defaults.loading);
  const [error, setError] = useState(defaults.error);
  const [res, setRes] = useState(defaults.data);
  useEffect(() => {
    if (defer) {
      setLoading(false);
      return () => undefined;
    }
    if (forceFetch) {
      setLoading(true);
    }
    let cancel = false;
    fn().then(result => {
      if (cancel) return;
      setRes(result && result.data ? result.data : result);
      setLoading(false);
    }, err => {
      if (cancel) return;
      setError(err);
      setRes([]);
      setLoading(false);
    });
    return () => {
      cancel = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- unknown deps
  }, deps);
  return {
    isLoading: defer ? false : loading || !res,
    isDeferred: !!defer,
    error,
    data: res
  };
};
export default useAsync;